var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelixLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 65,
    viewBox: "0 0 37 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.008%",
    x2: "50.008%",
    y1: "-113.852%",
    y2: "438.964%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "49.965%",
    x2: "49.965%",
    y1: "-45.327%",
    y2: "407.773%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "49.985%",
    x2: "49.985%",
    y1: "10.623%",
    y2: "389.182%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50.102%",
    x2: "50.102%",
    y1: "214.802%",
    y2: "-342.437%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50.136%",
    x2: "50.136%",
    y1: "145.363%",
    y2: "-307.737%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50.097%",
    x2: "50.097%",
    y1: "89.403%",
    y2: "-289.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.36%",
    stopColor: "#00B7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.65%",
    stopColor: "#00B0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ADEE"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.45 63.57L3.517 65V38.545l26.057-13.39V1.43L32.506 0v26.91L6.45 40.3v23.27zm9.315-33.67l-3.192 1.625-9.055-4.615v-9.165C1.498 17.095 0 15.275 0 13.065c0-2.73 2.215-4.94 4.95-4.94 2.737 0 4.952 2.21 4.952 4.94 0 2.21-1.499 4.095-3.518 4.68v7.41l9.38 4.745zM2.997 13.065c0 1.105.912 2.015 2.019 2.015 1.107 0 2.02-.91 2.02-2.015a2.027 2.027 0 0 0-2.02-2.015c-1.107 0-2.02.91-2.02 2.015zM36.024 52.26c0 2.73-2.215 4.94-4.95 4.94a4.943 4.943 0 0 1-4.952-4.94c0-2.21 1.499-4.095 3.518-4.68V40.3l-9.315-4.745 3.192-1.625 9.055 4.615v9.035c1.954.65 3.452 2.47 3.452 4.68zm-2.866 0a2.027 2.027 0 0 0-2.02-2.015c-1.107 0-2.02.91-2.02 2.015s.913 2.015 2.02 2.015c1.043.065 2.02-.845 2.02-2.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M14.152 27.473l1.857 1.062 1.393.779 9.616-5.31v-3.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12.293 25.49l10.865-5.526V16.57L9.006 23.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M9.006 21.667l16.725-8.292v-3.179L9.006 18.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M20.585 38.745l-1.866-1.07-1.334-.714-9.666 5.281v3.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M21.897 40.303L10.293 46.31v3.396l14.906-7.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M27.018 43.333l-16.725 8.292v3.179l16.725-8.291z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelixLogoSymbol);
export default __webpack_public_path__ + "static/media/helix-logo-symbol.f30ecc11.svg";
export { ForwardRef as ReactComponent };